<template>
  <div class="mb-2">
    <div :class="'row ' + (flexStart ? '' : 'flex-end')">
      <div
        v-for="(input, index) in row.columns"
        v-bind:key="input.name + String(Math.random(1023))"
        :class="
          'col-lg-' +
            (input.colwidth ? input.colwidth : 12 / row.colnum) +
            ' ' +
            (index > 0 ? 'pl-1' : '') +
            ' ' +
            (index < row.columns.length - 1 ? 'pr-1' : '')
        "
      >
        <FormGroupInline
          :input="input"
          :value="input.value"
          @handleChange="(e) => handleChange(e)"
          @handleBlur="(e) => handleBlur(e)"
        />
      </div>
    </div>
  </div>
</template>
<script>
import FormGroupInline from "./FormGroupInline.vue";
export default {
  name: "FormRowInline",
  components: {
    FormGroupInline,
  },
  props: {
    row: Object,
    flexStart: Boolean,
  },
  data: function() {
    return {};
  },
  methods: {
    handleChange(e) {
      this.$emit("handleChange", e);
    },
    handleBlur(e) {
      this.$emit("handleBlur", e);
    },
  },
};
</script>
